import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import style from '../../Meal/Item/style.module.less'
import Img from '@UI/Img'
import { Flex } from 'hljd'
import { MEAL_TAG_IMG } from '@constant'
import { CollectorsCount, Price } from '../../Common/Goods'

const fakeStyle = {
  img: {
    backgroundColor: '#eee',
    width: '100%',
    height: '100%',
    borderRadius: 12
  },
  info: {
    backgroundColor: '#eee',
    width: '100%',
    height: 18,
    marginBottom: 3
  },
  bottom: {
    backgroundColor: '#eee',
    width: '50%',
    height: 18
  }
}

/**
 * 除婚纱礼服和婚品，其他品类样式
 */
@inject('goodsStore')
@observer
class Item extends Component {
  getImgStyle = () => {
    return {
      width: 170,
      height: 114
    }
  }
  render() {
    const {
      cover_path,
      title,
      hot_tag,
      goodsStore: { fakeMode }
    } = this.props

    const imgSize = this.getImgStyle()

    return (
      <Flex className={style.item}>
        <div className={style.photo} style={imgSize}>
          {fakeMode ? (
            <div style={fakeStyle['img']} />
          ) : (
            <Img className={style.img} src={cover_path} style={imgSize} />
          )}

          <img className={style.hotTag} src={MEAL_TAG_IMG[hot_tag + '']} />
        </div>

        <Flex d="v" sp className={style.info}>
          {fakeMode ? (
            <div>
              <div style={fakeStyle['info']} />
              <div style={fakeStyle['info']} />
            </div>
          ) : (
            <div className={style.title}>{title}</div>
          )}

          {fakeMode ? (
            <div style={fakeStyle['bottom']} />
          ) : (
            <div className={style.content}>
              <div
                style={{
                  display: 'flex',
                  flexShrink: 1
                }}
              >
                <Price {...this.props} />
              </div>

              <CollectorsCount {...this.props} />
            </div>
          )}
        </Flex>
      </Flex>
    )
  }
}

export default ({ list }) => (
  <>{(list || []).map((item, index) => <Item key={index} {...item} />)}</>
)
